// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2mQh9","label":"Radio_label__3iy5P","checkMark":"Radio_checkMark__3ufUb","disabled":"Radio_disabled__2KbqX"};